import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=55559fb5&scoped=true"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"
import style0 from "./TheModal.vue?vue&type=style&index=0&id=55559fb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55559fb5",
  null
  
)

export default component.exports